import { User } from './user';

interface GetToken {
  token: string;
}

interface LoginSuccessAction {
  type: AuthActionTypes.LOGIN_SUCCESS;
  payload: GetToken;
}

interface LoginFailAction {
  type: AuthActionTypes.LOGIN_FAIL;
}

interface LogoutAction {
  type: AuthActionTypes.LOGOUT;
}

interface AddLoadingAction {
  type: AuthActionTypes.ADD_LOADING;
}

interface LoadUserAction {
  type: AuthActionTypes.LOAD_USER;
  payload: User;
}

interface LoadUserFailAction {
  type: AuthActionTypes.LOAD_USER_FAIL;
}

interface SetUrlAction {
  type: AuthActionTypes.SET_URL;
  payload: string;
}

export enum AuthActionTypes {
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGIN_FAIL = 'LOGIN_FAIL',
  LOGOUT = 'LOGOUT',
  LOAD_USER = 'LOAD_USER',
  LOAD_USER_FAIL = 'LOAD_USER_FAIL',
  ADD_LOADING = 'ADD_LOADING',
  SET_URL = 'SET_URL',
  SET_EMAIL_LOADING = 'SET_EMAIL_LOADING',
  SET_CAPTCHA_LOADING = 'SET_CAPTCHA_LOADING',
  GET_CAPTCHA_SCORE = 'GET_CAPTCHA_SCORE',
  CHECK_RESET_TOKEN = 'CHECK_RESET_TOKEN',
}

export interface AuthState {
  token: null | string;
  isAuthenticated: boolean;
  url: null | string;
  user: User;
  score: number;
  resetUser: null | string;
  resetTokenLoading: boolean;
  loading: boolean;
  userLoading: boolean;
  emailLoading: boolean;
}

export type AuthAction =
  | LoginSuccessAction
  | LoginFailAction
  | LoadUserAction
  | LogoutAction
  | AddLoadingAction
  | LoadUserFailAction
  | SetUrlAction;
